// /Users/tomlaan/Sites/pip/js/snippets/blocks.js
(function () {
    // Initialize foldout sections
    function initFoldouts() {
        const foldouts = document.querySelectorAll('.blocks__text-section__content--foldout');
        
        foldouts.forEach(foldout => {
            const headline = foldout.querySelector('.blocks__text-section__content__headline');
            
            if (headline) {
                // Add accessibility attributes
                headline.setAttribute('role', 'button');
                headline.setAttribute('aria-expanded', 'false');
                headline.setAttribute('tabindex', '0');
                
                // Add click handler specifically to headline
                headline.addEventListener('click', () => {
                    toggleFoldout(foldout, headline);
                });
                
                // Add keyboard support (Enter and Space)
                headline.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        toggleFoldout(foldout, headline);
                    }
                });
            }
        });
    }
    
    // Toggle foldout state
    function toggleFoldout(foldout, headline) {
        const isExpanded = foldout.classList.contains('is-expanded');
        
        // Toggle class
        foldout.classList.toggle('is-expanded');
        
        // Update aria-expanded
        headline.setAttribute('aria-expanded', String(!isExpanded));
        
        // Optional: Close other foldouts (accordion behavior)
        // Uncomment the lines below if you want only one foldout open at a time
        /*
        const allFoldouts = document.querySelectorAll('.blocks__text-section__content--foldout');
        allFoldouts.forEach(otherFoldout => {
            if (otherFoldout !== foldout && otherFoldout.classList.contains('is-expanded')) {
                otherFoldout.classList.remove('is-expanded');
                const otherHeadline = otherFoldout.querySelector('.blocks__text-section__content__headline');
                if (otherHeadline) {
                    otherHeadline.setAttribute('aria-expanded', 'false');
                }
            }
        });
        */
    }
    
    // Simple parallax: .blocks__image scrolls 25% slower than the page
    function initParallax() {
        const images = [...document.querySelectorAll('.blocks__image')];
        if (!images.length) return;

        // Cache document-relative tops before any transforms are applied
        const offsets = images.map(el => el.getBoundingClientRect().top + window.scrollY);

        function update() {
            const scrollY = window.scrollY;
            images.forEach((el, i) => {
                el.style.transform = `translateY(${(scrollY - offsets[i]) * 0.65}px)`;
            });
        }

        window.addEventListener('scroll', update, { passive: true });
        update();
    }

    // Initialize when DOM is ready
    document.addEventListener('DOMContentLoaded', () => {
        initFoldouts();
        initParallax();
    });
    
    // Re-initialize if new content is added dynamically
    document.addEventListener('blocks:refresh', initFoldouts);
})();